module.exports = __webpack_public_path__ + "static/media/035-paper.c1e568f7.svg";